export default __webpack_public_path__ + "static/diamonds-separator-8ca032b578e29bb37d58046303109abe.svg";